import axios from "axios";

const client = axios.create({
	baseURL: `${window.location.origin}/api`,
	headers: {
		"Content-Type": "application/json"
	}
});

export default client;
